export const colors = {
  grey: '#D7DDE0',
  pink: '#D71E8D',
  white: '#fff',
  black: '#000',
  surfaceDark: '#333',
  default: '#333',
  active: {
    tertiary: {
      dark: '#3E505D',
    },
  },
  formElements: {
    6: '#E4E8EA',
    12: '#F3F3F3',
  },
  brandChevron: 'rgb(219, 0, 17)',
};

export const breakpoints = {
  md: 851,
};

export const oneColumnLayout = `@media screen and (max-width: ${breakpoints.md}px)`;

export const twoColumnsLayout = `@media screen and (min-width: ${breakpoints.md}px)`;
